/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ChangeExpiredPasswordAliases {
  CHANGE_PASSWORD_SUBMIT_BUTTON = 'change-password-submit-button',
  CONFIRM_PASSWORD_FIELD = 'confirm-password-field',
  CONFIRM_PASSWORD_INPUT = 'confirm-password-input',
  CONFIRM_PASSWORD_VALIDATION_TEXT = 'confirm-password-validation-text',
  CONTEXTUAL_BAR_RENEW_PASSWORD = 'contextual-bar-renew-password',
  FORM_LAYOUT = 'form-layout',
  GLOBAL_ACTIONS_SUBMIT_BUTTON_CHANGE_EXPIRED_PASSWORD = 'global-actions-submit-button-change-expired-password',
  NEW_PASSWORD_FIELD = 'new-password-field',
  NEW_PASSWORD_INPUT = 'new-password-input',
  NEW_PASSWORD_VALIDATION_TEXT = 'new-password-validation-text',
  OLD_PASSWORD_FIELD = 'old-password-field',
  OLD_PASSWORD_INPUT = 'old-password-input',
  OLD_PASSWORD_VALIDATION_TEXT = 'old-password-validation-text',
  PANEL_FORM = 'panel-form',
  RENEW_FORM = 'renew-form',
  RENEW_LAYOUT = 'renew-layout',
  TOAST_NOTIFICATION_DESKTOP = 'toast-notification-desktop',
}
export { ChangeExpiredPasswordAliases };
